import { render, staticRenderFns } from "./AttachmentBtnBase.vue?vue&type=template&id=32c75e7c&scoped=true&"
import script from "./AttachmentBtnBase.vue?vue&type=script&lang=js&"
export * from "./AttachmentBtnBase.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentBtnBase.vue?vue&type=style&index=0&id=32c75e7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c75e7c",
  null
  
)

export default component.exports